const shopAllUrl = (href, searchPath, allPath, origin) => {
  let url;
  try {
    url = new URL(href, origin);
  } catch {
    return null;
  }
  if (url.origin !== origin || url.pathname.replace(/\/$/, '') !== allPath.replace(/\/$/, '')) return null;
  url.pathname = searchPath;
  url.searchParams.set('q', '*');
  url.searchParams.set('type', 'product');
  url.searchParams.delete('view');
  url.searchParams.delete('page');
  return url;
};

const routes = document.querySelector('[data-avt-shopping-routes]');
const updateShopAllLinks = () => {
  if (!routes) return;
  for (const link of document.querySelectorAll('a[href]')) {
    const url = shopAllUrl(link.href, routes.dataset.searchUrl, routes.dataset.allUrl, location.origin);
    if (url) link.href = url.href;
  }
};

updateShopAllLinks();
document.addEventListener('shopify:section:load', updateShopAllLinks);
if (routes) {
  const url = shopAllUrl(location.href, routes.dataset.searchUrl, routes.dataset.allUrl, location.origin);
  if (url && !window.Shopify?.designMode) location.replace(url.href);
}

document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-avt-bike-picker]');
  if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const drawer = document.getElementById('avt-bike-picker');
  if (typeof drawer?.showDialog !== 'function') return;
  event.preventDefault();
  drawer.showDialog();
});
